export const UPDATE_MOVE_DATE = 'UPDATE_MOVE_DATE';

export const UPDATE_APPOINTMENT_DATA = 'UPDATE_APPOINTMENT_DATA';

export const MOVERS_UPDATECART_SUCCESS = 'MOVERS_UPDATECART_SUCCESS';
export const UPDATE_APPOINTMENT_DATE = 'UPDATE_APPOINTMENT_DATE';

export const ERR_OCCUREDMV = 'ERR_OCCUREDMV';

export const MOVERS_RETRIEVE_CART = 'MOVERS_RETRIEVE_CART';
export const UPDATE_CART_DATA = 'UPDATE_CART_DATA';

export const UPDATE_ERROR_INFO = 'UPDATE_ERROR_INFO';
export const UPDATE_SUSPEND_INFO = 'UPDATE_SUSPEND_INFO';

export const MOVERS_ORDER_WRITE = 'MOVERS_ORDER_WRITE';
export const UPDATE_ORDER_NUMBER = 'UPDATE_ORDER_NUMBER';

export const UPDATE_DISCONNECT_DATE = 'UPDATE_DISCONNECT_DATE';

export const FETCH_MOVERS_ALL_PLANS = 'FETCH_MOVERS_ALL_PLANS';
export const FETCH_MOVERS_PLAN = 'FETCH_MOVERS_PLAN';
export const STORE_MOVERS_ALL_PLANS_DETAILS = 'STORE_MOVERS_ALL_PLANS_DETAILS';
export const STORE_MOVERS_PLANS = 'STORE_MOVERS_PLANS';
export const MOVERS_UPDATE_CUSTOMER_PLAN = 'MOVERS_UPDATE_CUSTOMER_PLAN';
export const STORE_MOVERS_PLAN = 'STORE_MOVERS_PLAN';

export const COMPARE_PLAN_API = 'COMPARE_PLAN_API';
export const COMPARE_PLAN_API_STATUS = 'COMPARE_PLAN_API_STATUS';
export const GET_MOVER_PLANS_ERROR = 'GET_MOVER_PLANS_ERROR';

export const GET_MOVERS_NBS = 'GET_MOVERS_NBS';
export const STORE_MOVERS_NBS = 'STORE_MOVERS_NBS';

export const GET_MOVERS_IMPORTANT_ACCOUNT_CHANGES = 'GET_MOVERS_IMPORTANT_ACCOUNT_CHANGES';
export const STORE_MOVERS_IMPORTANT_ACCOUNT_CHANGES = 'STORE_MOVERS_IMPORTANT_ACCOUNT_CHANGES';
export const STORE_MOVERS_WHOLE_HOME_WIFI_DETAILS = 'STORE_MOVERS_WHOLE_HOME_WIFI_DETAILS';

export const GET_AGREEMENT = 'GET_AGREEMENT';
export const GET_AGREEMENT_DETAILS = 'GET_AGREEMENT_DETAILS';
export const STORE_MTN = 'STORE_MTN';
